import { ListPageHeader } from '@/components/common/ListPageHeader'
import { CustomerTable } from './components/CustomerTable'
import { CustomerCreateButton } from './components/CustomerCreateButton'

export function CustomerListPage() {
  return (
    <div className="flex flex-col w-full">
      <ListPageHeader
        title="Klienci"
        subtitle="Lista klientów"
        actions={<CustomerCreateButton />}
      />
      <div className="p-4">
        <CustomerTable />
      </div>
    </div>
  )
}
